import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export const Typewriter = ({ 
  text, 
  speed = 100, 
  delay = 0,
  className = "",
  style = {},
  cursor = true 
}) => {
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, delay + currentIndex * speed);

      return () => clearTimeout(timeout);
    } else if (cursor) {
      // Blinking cursor after typing is complete
      const cursorTimeout = setTimeout(() => {
        setShowCursor(prev => !prev);
      }, 500);
      return () => clearTimeout(cursorTimeout);
    }
  }, [currentIndex, text, speed, delay, cursor]);

  return (
    <motion.span 
      className={className}
      style={style}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {displayText}
      {cursor && currentIndex >= text.length && (
        <motion.span
          animate={{ opacity: showCursor ? 1 : 0 }}
          transition={{ duration: 0.1 }}
          className="inline-block w-1 h-full bg-current ml-1"
        >
          |
        </motion.span>
      )}
    </motion.span>
  );
};